import {Box} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';

export abstract class DistributionMenu
{
    public static build(target:Box):Array<IContextMenuItem>
    {
        const {surfaceArea} = controllers.ui;

        const distributionMenuItems = [
            {
                label: 'Horizontally',
                handler: surfaceArea.distributeSelectedBoxesHorizontally
            },
            {
                label: 'Vertically',
                handler: surfaceArea.distributeSelectedBoxesVertically
            }
        ];

        return [
            {
                label: '',
                isSeparator: true
            },
            {
                label: 'Distribute',
                dataSource: distributionMenuItems,
                isDisabled: !surfaceArea.isDistributionActionAvailable()
            }
        ];

    }
}
